const EditionPanelVariants = {
  HOMEPAGE: 'HOMEPAGE',
  CHAPTER: 'CHAPTER',
  QUIZ: 'QUIZ',
} as const;

export default EditionPanelVariants;
